import { EditRequestHeader } from "./components/EditRequestHeader.tsx";
import { InformationBar } from "./components/InformationBar.tsx";

export function Header() {
  return (
    <header className="static md:top-0 z-10 sm:static sm:z-auto flex gap-lg flex-col">
      <EditRequestHeader />
      <InformationBar />
    </header>
  );
}
